<template>

	<div id="footer">
		<div class="footer">
			<div class="container">
				<!--<div class="siteinfo">
					<ul class="nav-footer">
						<li class='first_li'>
							<h3>媒体中心  </h3>
							<ul>
								<li class='last_li'>
									<a _ href="//www.smartisan.com/support/#/instruction">新闻动态</a>
								</li>

								<li class='last_li'>
									<a _ href="//www.smartisan.com/support/#/delivery">图片资源</a>
								</li>
							</ul>
						</li>

						<li class='first_li'>
							<h3>关于公司  </h3>
							<ul>

								<li class='last_li'>
									<a _ href="//www.smartisan.com/support/#/instruction">公司简介</a>
								</li>

								<li class='last_li'>
									<a _ href="//www.smartisan.com/support/#/delivery">联系我们</a>
								</li>
							</ul>
						</li>

						<li class='first_li'>
							<h3>关注我们  </h3>
							<ul>

								<li class='last_li'>
									<a _ href="//www.smartisan.com/support/#/instruction">新浪微博</a>
								</li>
								<li class='last_li'>
									<a _ href="//www.smartisan.com/support/#/payment">官方微信</a>
								</li>

							</ul>
						</li>
					</ul>

					<ul class="service">
						<li class="tel">024-26400512</li>
						<li class="time">周一至周五 8:00-17:00（</li>

					</ul>
				</div>-->
				<div class="copyright">
					<h4>Copyright ©, ChiGuan Technology Co., Ltd. All Rights Reserved.</h4>
					<h5 class="company">沈阳驰冠科技有限公司</h5>
					<ul class="privacy">
						<li>
							<!--<a href="//www.cyber-lock.top">无源电子锁管理系统</a>-->
						</li>
						
					</ul>
					<h6> 
						<a href="https://beian.miit.gov.cn/" target="_blank">
							<span>辽ICP备2021012673号-3</span></a>
						<a href="http://www.beian.gov.cn/" target="_blank">
							<span>辽公网安备21010302666695号</span>
						</a> 
						
						</h6>
				</div>
			</div>
		</div>
        
		<QQonline></QQonline>

	</div>
</template>

<script>
	import QQonline from '@/components/qq-online'
	export default{
		components:{
			QQonline
		}
	}

</script>
<!--代码部分end-->

<style>
		
	#right {
		float: right;
		position: fixed;
		right: 20px;
		bottom: 100px;
		z-index: 99999999;
	}
	
	.footer {
		background: #fafafa;
		border-top: 1px solid #e6e6e6;
		display: block;
	}
	
	.container {
		width: 1220px;
		margin-left: auto;
		margin-right: auto;
	}
	
	.footer .siteinfo {
		height: 50px;
		padding: 30px 0 32px;
		border-bottom: 1px solid #e6e6e6;
		position: relative;
	}
	
	.footer .copyright {
		color: #434d55;
		font-size: 12px;
		padding: 40px 0;
	}
	
	.nav-footer h3 {
		color: #646464;
		font-size: 12px;
		padding: 0 0 14px;
	}
	
	.nav-footer a {
		color: #969696;
	}
	
	.first_li {
		width: 149px;
		line-height: 1;
		float: left;
	}
	
	.last_li {
		color: #c3c3c3;
		font-size: 12px;
		padding: 6px 0;
	}
	
	.service {
		float: right;
		position: absolute;
		right: 0;
		overflow: hidden;
		line-height: 34px;
	}
	
	.footer .service .tel {
		text-align: right;
		font-size: 30px;
		line-height: 1;
		cursor: default;
		color: #646464;
		top: -2px;
		position: relative;
	}
	
	.service .time {
		clear: both;
		width: 241px;
		font-size: 12px;
		line-height: 18px;
		color: #c3c3c3;
		text-align: right;
	}
	
	.footer .service li.online a {
		float: right;
		width: 102px;
		height: 32px;
		line-height: 32px;
		background: linear-gradient(#fcfcfc, #f5f5f5);
		cursor: pointer;
		font-size: 14px;
		padding: 0 0 0 26px;
		margin-top: 8px;
		text-align: left;
		color: #5079d9;
		border: 1px solid #dcdcdc;
		border-radius: 5px;
	}
	
	.footer .copyright h4,
	.footer .copyright h5 {
		float: left;
		height: 15px;
		line-height: 15px;
		color: #757575;
	}
	
	.footer .privacy {
		float: left;
		margin: 0 0 0 12px;
	}
	
	.footer .privacy li {
		float: left;
		line-height: 12px;
		padding: 1px 10px 0;
		border-left: 1px solid #ccc;
	}
	
	.footer .privacy li a {
		color: #5079d9;
		cursor: pointer;
		transition: all .15s ease-out;
		text-decoration: none;
	}
	
	.footer .copyright h6 {
		clear: both;
		padding: 10px 0 0;
		height: 15px;
	}
	
	.footer .copyright h6 a {
		color: #bdbdbd;
		font-size: 12px;
		height: 12px;
		line-height: 1;
	}
	
	.footer .copyright h6 span {
		margin-right: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/footer-nav.vue